<template>
  <div>
    <v-form>  
      <v-container>
        <v-row >
          <v-col cols="12" xs="12" md="6" sm="6">
            <v-row>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field label="Server" :class="classPadding" v-model="model.server"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field label="Username" :class="classPadding" v-model="model.username"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field label="Password" :class="classPadding" v-model="model.password" type="password"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field label="Data Source" :class="classPadding" v-model="model.dataSource"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" xs="12" md="6" sm="6">
            <v-row>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field readonly :class="classPadding" v-model="result.server"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field readonly :class="classPadding" v-model="result.username"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field readonly :class="classPadding" v-model="result.password"></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
                <v-text-field readonly :class="classPadding" v-model="result.dataSource"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" md="12" sm="12" :class="classPadding">
            <v-btn text color="success" :class="classPadding" outlined @click.stop="encrypt" :loading="loadingEncrypt">Encrypt</v-btn>&nbsp;
            <v-btn text color="primary" :class="classPadding" outlined @click.stop="decrypt" :loading="loadingDecrypt">Decrypt</v-btn>
          </v-col>
        </v-row>
      </v-container>
     </v-form>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/security"
export default {
  metaInfo: {
    title: "Security v79",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    classPadding: "my-0 py-0",
    title: "Security",
    model: {},
    result: {},
    loadingEncrypt: false,
    loadingDecrypt: false,
  }),
  methods: {
    encrypt(){
      this.loadingEncrypt = true
      this.$axios.post(`${API_ENDPOINT}/encrypt`, this.model)
        .then(({ data }) => {
          this.result = data;
        })
        .catch(({ response }) => {
          this.$toast.show(response.data);
          this.isSaving = false;
        })
        .finally(() => {
          this.loadingEncrypt = false
        })
    },
    decrypt() {
      this.loadingDecrypt = true
      this.$axios.post(`${API_ENDPOINT}/decrypt`, this.model)
        .then(({ data }) => {
          this.result = data;
        })
        .catch(({ response }) => {
          this.$toast.show(response.data);
          this.isSaving = false;
        })
        .finally(() => {
          this.loadingDecrypt = false
        })
    }
  }
}
</script>